/**
 * Constants shared by the client, servers and tools.
 * Timing values are defined in docs/05-netcode.md.
 */

export const GAME_NAME = 'NEIMAbattle';

/** Bumped on any breaking change to the client/server wire protocol. */
export const PROTOCOL_VERSION = 1;

/** Authoritative simulation rate (server and client prediction). */
export const SIM_TICK_HZ = 60;
export const SIM_DT = 1 / SIM_TICK_HZ;

/** Server to client snapshot rate. */
export const SNAPSHOT_HZ = 30;

/** Environments deployed on battle-01. See docs/08-infrastructure-and-deployment.md. */
export const DEPLOY_ENVS = ['prod', 'staging', 'preview-1', 'preview-2', 'preview-3'] as const;
export type DeployEnv = (typeof DEPLOY_ENVS)[number];

/** Messages exchanged on the M0 transport check (text frames). Replaced by the binary protocol in M2. */
export type ClientMessage = { t: 'ping'; c: number };
export type ServerMessage =
  | { t: 'hello'; gs: string; protocol: number; version: string }
  | { t: 'pong'; c: number; s: number };
